import { Invoice } from "../../../buy/services/invoice.model";
import { Action } from "../../../common/actions/core/action";

export class NoAuthBillInfoChangeAction implements Action {
    constructor(public invoice: Invoice) {}
}  


// WEBPACK FOOTER //
// src/app/no-auth/components/actions/bill-info-change.action.ts